'use client'

import { useState, useEffect } from 'react';
import { SwiperContainer } from '@/components/containers/swiper-container';
import { pageTabBarStyle } from './page-tab-bar.style';
import clsx from 'clsx';
import { useAnalyseAttribute } from '@/features/next-analyse';

type PageTabBarProps = {
	tabList: TabItem[];
	onTabLink: (index: number) => void;
	tabDefaultIndex?: number;
	isMyBetHasBooked?: boolean;
	className?: string;
}

type TabItem = {
	slug: string;
	name: string;
	isShowHint?: boolean;
}
const PageTab = ({ name, slug }: TabItem) => {
	const analyseKey = ({
		'Cash Out': 'check-cash-out',
		Open: 'check-open-tickets',
		Settled: 'check-settled-tickets',
		Result: 'check-results'
	})[name] || '';
	const taggedElement = useAnalyseAttribute(analyseKey);
	return (
		<span
			key={slug}
			className="tab__text"
			ref={taggedElement}
		>
			{name}
		</span>
	);
};

export const PageTabBar = ({ tabList, onTabLink, tabDefaultIndex, isMyBetHasBooked, className  }: PageTabBarProps) => {
	const [currentTabIndex, setCurrentTabIndex] = useState(tabDefaultIndex);

	useEffect(() => {
		setCurrentTabIndex(tabDefaultIndex);
	}, [tabDefaultIndex]);

	const tabText = tabList.map((item) => {
		return (
			<>
				<PageTab {...item} />
				{item.slug==='b' && item.isShowHint && <div className="badge badge--point"></div>}
			</>
		)
	})

	return (
		<section className={clsx('page-filter', pageTabBarStyle.pageFilter, className)}>
			<SwiperContainer
				className="tab tab--pills"
				slideElements={tabText}
				currentIndex={currentTabIndex}
				elementClassName="tab__item"
				onSlideClick={onTabLink}
				isMyBetHasBooked={isMyBetHasBooked}
			/>
		</section>
	)
}